import {
  AUTO_PAY_AMOUNT_CHANGED,
  AUTO_PAY_CHANGED,
  AUTO_PAY_DEATILS_LOADED,
  AUTO_PAY_METHOD_CHANGED,
  BILL_DEATILS_LOADED,
  BILL_REMINDERS_DEATILS_LOADED,
  PAGE_MODE_CHANGED,
  RESET_INIT_STATE,
} from "./Actions";
import { billInitailState } from "./billState";

const BillReducer = (state, action) => {
  switch (action.type) {
    case AUTO_PAY_AMOUNT_CHANGED: {
      const payAmountChanged = state.intialAutoPayDetails
        ? state.intialAutoPayDetails.maxLimitAmount !== action.payload
        : true;
      const autoPayDetails = state.autoPayDetails ? state.autoPayDetails : {};
      autoPayDetails.maxLimitAmount = +action.payload;
      return {
        ...state,
        autoPayDetails: autoPayDetails,
        autoPayAmoutChanged: payAmountChanged,
      };
    }
    case AUTO_PAY_METHOD_CHANGED: {
      const payModeChanged = state.intialAutoPayDetails
        ? state.intialAutoPayDetails.preferredPaymentMode !== action.payload
        : true;
      const autoPayDetails = state.autoPayDetails ? state.autoPayDetails : {};
      autoPayDetails.preferredPaymentMode = action.payload;
      return {
        ...state,
        autoPayDetails: autoPayDetails,
        autoPayMethodChanged: payModeChanged,
      };
    }
    case AUTO_PAY_DEATILS_LOADED:
      return {
        ...state,
        autoPayDetails: action.payload,
        intialAutoPayDetails: { ...action.payload },
      };
    case PAGE_MODE_CHANGED:
      return { ...state, isEditing: action.payload };
    case AUTO_PAY_CHANGED:
      return { ...state, autoPayEnabled: action.payload };
    case BILL_DEATILS_LOADED:
      return {
        ...state,
        billDetails: action.payload,
        autoPayEnabled: action.payload?.autoPay,
      };
    case BILL_REMINDERS_DEATILS_LOADED:
      return {
        ...state,
        remindersData: action.payload,
      };
    case RESET_INIT_STATE:
      return billInitailState;
    default:
      return state;
  }
};

export default BillReducer;
